import normalize from '@/utils/statistics/normalize';

type Attendance = {
  presences: number;
  totalReports: number;
};

/**
 * @deprecated Use `percentage` from `@/utils/statistics/percentage` instead:
 * `percentage(presences / totalReports)`.
 */
export default function attendancePercentage({
  presences,
  totalReports,
}: Attendance): number {
  const attendance = (presences / totalReports) * 100;
  return normalize(attendance);
}
